import { render, staticRenderFns } from "./CustomerCard.vue?vue&type=template&id=3e98efb6&scoped=true"
import script from "./CustomerCard.vue?vue&type=script&lang=ts"
export * from "./CustomerCard.vue?vue&type=script&lang=ts"
import style0 from "./CustomerCard.vue?vue&type=style&index=0&id=3e98efb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e98efb6",
  null
  
)

export default component.exports